import { CATALOG_ROUTE, ERROR_ROUTE } from '@/router/routes/route-names'

export const disableErrorRouteManualNavigation = (to, from, next) => {
  const { name, params } = to || {}
  if (name === ERROR_ROUTE && !params.allowNavigation) {
    next({ name: CATALOG_ROUTE, params })
  } else {
    next()
  }
}
